/* tslint:disable */
/* eslint-disable */
/**
 * Atelier Roles API
 * L\'Atelier des rôles (BO admin) : référentiel des briques (standard verrouillées, personnalisées administrables), profils (ensembles de rôles appliqués à la création des acteurs) et matrice rôles/portails. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProfilDto
 */
export interface ProfilDto {
    /**
     * 
     * @type {string}
     * @memberof ProfilDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilDto
     */
    nom: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfilDto
     */
    roles: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfilDto
     */
    natures: Array<string>;
}

/**
 * Check if a given object implements the ProfilDto interface.
 */
export function instanceOfProfilDto(value: object): value is ProfilDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('nom' in value) || value['nom'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('natures' in value) || value['natures'] === undefined) return false;
    return true;
}

export function ProfilDtoFromJSON(json: any): ProfilDto {
    return ProfilDtoFromJSONTyped(json, false);
}

export function ProfilDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfilDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'nom': json['nom'],
        'description': json['description'] == null ? undefined : json['description'],
        'roles': json['roles'],
        'natures': json['natures'],
    };
}

export function ProfilDtoToJSON(json: any): ProfilDto {
    return ProfilDtoToJSONTyped(json, false);
}

export function ProfilDtoToJSONTyped(value?: ProfilDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'nom': value['nom'],
        'description': value['description'],
        'roles': value['roles'],
        'natures': value['natures'],
    };
}

